import {
  Box,
  Button,
  createStyles,
  Input,
  Modal,
  ScrollArea,
  Table,
  Text,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import moment from "moment-timezone";
import { DatePickerInput } from "@mantine/dates";

const useStyles = createStyles(() => ({
  container: {
    padding: "12px 12px 20px 30px",
    borderRadius: "12px",
    border: "1px solid var(--app-border)",

    background: "var(--app-surface-2)",
  },
  searchResultListWrapper: {
    maxHeight: "350px",
    overflowY: "auto",
    marginTop: "16px",
    background: "var(--app-surface)",
    padding: "20px 16px",
    borderRadius: "12px",
    border: "1px solid var(--app-border)",
  },
  tableHead: {
    color: "var(--app-text)",
    fontWeight: "700",
    fontSize: "14px",
    fontFamily: "Inter",
  },

  //   addbox:{

  //    borderRadius: "12px",
  // border: "1px solid var(--app-border)",
  // background: "var(--app-surface)",
  //   },

  header: {
    color: "var(--app-text) !important",
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
  },

  input: {
    color: "var(--app-text) !important",
    fontFamily: "Inter !important",
    fontSize: "16px !important",
    fontWeight: "400 !important",
    background: "var(--app-surface) !important",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },
  searchResultList: {
    width: "100%",
    margin: "0 auto",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    "& thead": {
      position: "sticky",
      top: 0,
      backgroundColor: "var(--app-surface)",
      zIndex: 1,
    },
    "& tbody tr:first-child": {
      width: "20%",
    },
    // "& tbody tr": {
    //   td: {
    //     width: "50%",
    //     borderTop: "1px solid var(--app-text-muted)",
    //     padding: "10px 20px",

    //   },
    // },
  },
}));

function ViewClientClaimServices({
  existingServices,
  showservice,
  setShowservices,
  SetFinalServcices,
  billingdate,
  finalservices,
  edit,
  setEdit,



}) {
  const { classes } = useStyles();

  const today = new Date();
  //const today = moment();
  //  console.log('existingServices',existingServices);

  //  console.log('finalservices',finalservices);

  // Initialize the providerServices state with servicechargeAmount and patientId
  const [providerServices, setProviderServices] = useState([]);
  const [scrolled, setScrolled] = useState(false);
  // const [edit,setEdit]=useState(false)
  // const [selectedIndex, setSelectedIndex] = useState(null);

  const { billingnotes, loading } = useSelector((state) => state?.note);

  //  console.log('providerServices',providerServices);

  // useEffect(() => {
  //   if (existingServices?.form1?.services && existingServices.id) {
  //     const initializedServices = existingServices.form1.services.map(service => ({
  //       ...service,
  //       patientId: existingServices.id,
  //       serviceRate: "",
  //       totalCost: 0,
  //     }));
  //     setProviderServices(initializedServices);
  //   }
  // }, [existingServices, existingServices.id]);

  // useEffect(() => {
  //   if (existingServices?.form1?.services && existingServices.id) {

  //     const initializedServices = existingServices.form1.services.map(service => {

  //       console.log('service',service);

  //       const matchingNote = billingnotes?.data?.find(note => note?.fields?.['Service Type']
  //         === service?.servicenumber  && note?.fields?.['Client Name'] === existingServices.id

  //       );

  //       console.log('matchingNote',matchingNote)

  //       const serviceRate = matchingNote
  //         ? matchingNote?.fields?.
  //         ['Unit/Day/Hours']?.split(',')
  //             .reduce((total, item) => total + parseFloat(item), 0)
  //         : 0;

  //       return {
  //         ...service,
  //         patientId: existingServices.id,
  //         serviceRate: serviceRate,
  //         totalCost: serviceRate * service?.servicechargeAmount,
  //       };
  //     });

  //     // Update the state with the initialized services
  //     setProviderServices(initializedServices);
  //   }
  // }, [existingServices, billingnotes?.data]);

  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  function weeklyformatDate(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed, so add 1
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  useEffect(() => {
    if (
      existingServices?.form1?.services &&
      existingServices?.id &&
      billingdate?.billingdata !== "manualbilling"
    ) {
      //     const initializedServices = existingServices.form1.services.map(service => {
      //       console.log('service', service);
      let initializedServices = [];
     

      console.log("finalservices", finalservices);

      if (finalservices?.length > 0) {
        initializedServices = finalservices?.map((service) => {
          const matchingService = existingServices?.form1?.services?.find(
            (item) =>
              String(service.patientId) === String(existingServices.id) &&
              String(service.servicetitle) === String(item.servicetitle) &&
              String(service.servicenumber) === String(item.servicenumber)
          );

          if (matchingService) {
            return {
              ...service,
            };
          } else {
            return null;
          }
        });

        initializedServices = initializedServices.filter(
          (service) => service !== null
        );

        const servicesToAdd = existingServices.form1.services.map(
          (service) => ({
            ...service,
            patientId: existingServices.id,
            serviceRate: 0,
            totalCost: 0,
          })
        );

        const uniqueServices = servicesToAdd.filter(
          (newService) =>
            !initializedServices.some(
              (existingService) =>
                existingService.patientId === newService.patientId
            )
        );

        initializedServices = [...initializedServices, ...uniqueServices];
      }

      setProviderServices(initializedServices);

    }

    else if (
      existingServices?.form1?.services?.length > 0 &&
      existingServices?.id &&
      billingdate?.billingdata === "manualbilling"
    ) {
      let initializedServices = [];

      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      console.log("userTimezone", userTimezone);

      if (finalservices?.length > 0) {
        initializedServices = finalservices?.map((service) => {
          const matchingService = existingServices?.form1?.services?.find(
            (item) =>
              String(service.patientId) === String(existingServices.id) &&
              String(service.servicetitle) === String(item.servicetitle) &&
              String(service.servicenumber) === String(item.servicenumber)
          );

          if (matchingService) {
            return {
              ...service,
            };
          } else {
            return null;
          }
        });

        initializedServices = initializedServices.filter(
          (service) => service !== null
        );

        // const servicesToAdd = existingServices.form1.services.map(service => ({
        //   ...service,
        //   patientId: existingServices.id,
        //   serviceRate: "",
        //   totalCost: 0,
        // }));

        const servicesToAdd = [];
        const { startdate, enddate, billingschedule } = billingdate || {};

        if (startdate && enddate) {
          const startDate = new Date(startdate);
          const endDate = new Date(enddate);

          // Calculate the difference in days
          const timeDifference = endDate - startDate;
          const daysDifference = timeDifference / (1000 * 3600 * 24); // Convert milliseconds to days

          console.log("Difference in days: ", daysDifference);

          // let monthsDifference = endDate.getMonth() - startDate.getMonth() + (12 * (endDate.getFullYear() - startDate.getFullYear()));
          let monthsDifference =
            (endDate.getFullYear() - startDate.getFullYear()) * 12 +
            (endDate.getMonth() - startDate.getMonth());

          // console.log('Initial monthsDifference:', monthsDifference);

          // console.log('endDate.getMonth()',endDate.getMonth());
          // console.log('startDate.getMonth()',startDate.getMonth());

          // Adjust months difference if the endDate day is earlier than startDate day in the end month
          if (endDate.getMonth() < startDate.getMonth()) {
            console.log("in the if");

            monthsDifference--;

            console.log(
              "Adjusted monthsDifference after day check:",
              monthsDifference
            );
          }
          monthsDifference++;
          // console.log('Final monthsDifference:', monthsDifference);

          // const weeksDifference = Math.floor(daysDifference / 7);
          const timeDiff = endDate - startDate;
          const weeksDifference = Math.ceil(timeDiff / (1000 * 3600 * 24 * 7));

          // Initialize servicesToAdd array to hold all the service objects

          existingServices.form1.services.forEach((service) => {
            if (service?.servicechargetype === "daily") {
              const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
              for (let i = 0; i <= daysDifference; i++) {
                // const serviceDate = new Date(startDate);
                // serviceDate.setDate(serviceDate.getDate() + i);
                const currentMoment = moment.tz(startDate, userTimezone).add(i, "days");
                // console.log('currentMoment',currentMoment);

                const formatted = currentMoment.format("YYYY-MM-DD");

                servicesToAdd.push({
                  ...service,
                  patientId: existingServices.id,
                  serviceRate: 0,
                  totalCost: 0,
                  billingschedule: 'daily',
                  serviceDate: `${formatted} - ${formatted}`,
                  //  serviceDate: new Date(serviceDate).toISOString().split("T")[0], // Use the incremented date
                //   serviceDate: new Date(
                //     serviceDate.setDate(serviceDate.getDate() + 1)
                //   )
                //     .toISOString()
                //     .split("T")[0],
                 });
              }
            }
          });

          existingServices.form1.services.forEach((service) => {
            if (billingschedule === "monthly") {
              console.log("in the month");

              const userTimezone =
                Intl.DateTimeFormat().resolvedOptions().timeZone;
              let current = moment.tz(startDate, userTimezone);

              for (let i = 0; i < monthsDifference; i++) {
                // let monthStart = new Date(current);
                // let monthEnd = new Date(current);
                let monthStart;
                let monthEnd;

                if (i === 0) {
                  monthStart = moment
                    .tz(startDate, userTimezone)
                    .startOf("day");
                  // monthStart.setDate(monthStart.getDate() + 1);
                  // Use the selected start date
                } else {
                  // monthStart.setDate(1); // Otherwise, set it to the 1st of the current month
                  // monthStart.setDate(monthStart.getDate() + 1);
                  // monthStart.setMonth(current.getMonth());
                  // monthStart.setDate(1);
                  monthStart = moment(current).startOf("month");
                }

                monthEnd = moment(monthStart).endOf("month");

                // For the last month, use the selected end date as the end date
                if (i === monthsDifference) {
                  monthEnd = moment.tz(endDate, userTimezone).endOf("day");
                  // monthEnd = new Date(endDate); // Set to the selected end date
                  // monthEnd.setHours(0, 0, 0, 0);
                }

                servicesToAdd.push({
                  ...service,
                  patientId: existingServices.id,
                  serviceRate: 0,
                  totalCost: 0,
                  serviceDate: `${formatDate(monthStart)} - ${formatDate(
                    monthEnd
                  )}`,
                  billingschedule: "monthly",
                });

                current.add(1, "month");
                // current.setMonth(current.getMonth() + 1);
              }
            }

            // For weekly billing schedule
            if (billingschedule === "weekly") {
              // let current = new Date(startDate);  // Start from the selected start date

              const userTimezone =
                Intl.DateTimeFormat().resolvedOptions().timeZone;

              let current = moment.tz(startDate, userTimezone).startOf("day");
              const finalDate = moment.tz(endDate, userTimezone).endOf("day");
              let isFirstWeek = true;

         
              while (current.isSameOrBefore(finalDate, "day")) {
                let weekStart = moment(current);
                let weekEnd;

                if (isFirstWeek) {
                  // First week ends on the upcoming Saturday
                  const dayOfWeek = weekStart.day(); // 0 = Sunday, 6 = Saturday
                  const daysUntilSaturday = 6 - dayOfWeek;
                  weekEnd = moment(weekStart).add(daysUntilSaturday, "days");
                  isFirstWeek = false;
                } else {
                  weekStart = moment(current).startOf("week"); // Sunday
                  weekEnd = moment(current).endOf("week"); // Saturday
                }

                if (weekEnd.isAfter(finalDate)) {
                  weekEnd = moment(finalDate);
                }

                servicesToAdd.push({
                  ...service,
                  patientId: existingServices.id,
                  serviceRate: 0,
                  totalCost: 0,
                  serviceDate: `${weekStart.format(
                    "YYYY-MM-DD"
                  )} - ${weekEnd.format("YYYY-MM-DD")}`,
                  billingschedule: "weekly",
                });

                // Move to the next week: Sunday after current weekEnd
                current = moment(weekEnd).add(1, "day").startOf("day");
              }
            }

            if(billingschedule === "exactdate"){
              console.log("in exactdate");
              const userTimezone =
              Intl.DateTimeFormat().resolvedOptions().timeZone;

              const oneTimeStart = moment.tz(startDate, userTimezone).startOf("day");
              const oneTimeEnd = moment.tz(endDate, userTimezone).endOf("day");
            
              servicesToAdd.push({
                ...service,
                patientId: existingServices.id,
                serviceRate: 0,
                totalCost: 0,
                serviceDate: `${oneTimeStart.format("YYYY-MM-DD")} - ${oneTimeEnd.format("YYYY-MM-DD")}`,
                billingschedule: "exactdate",
              });
            }


            // if (service?.servicechargetype === "month") {
            //   servicesToAdd.push({
            //     ...service,
            //     patientId: existingServices.id,
            //     serviceRate: 0,
            //     totalCost: 0,
            //     serviceDate: "",
            //   });
            // }
          });

          // initializedServices = [...initializedServices, ...servicesToAdd];
        }

        const uniqueServices = servicesToAdd.filter(
          (newService) =>
            !initializedServices.some(
              (existingService) =>
                existingService.patientId === newService.patientId
            )
        );

        initializedServices = [...initializedServices, ...uniqueServices];
      }

      // else {
      //   console.log('in the else');
      //   initializedServices = existingServices.form1.services.map(service => ({
      //     ...service,
      //     patientId: existingServices.id,
      //     serviceRate: "",
      //     totalCost: 0,
      //   }));
      // }
      else {
        const { startdate, enddate, billingschedule } = billingdate || {};

        // console.log('billingschedule',billingschedule);

        // Check if both startdate and enddate are valid
        if (startdate && enddate) {
          const startDate = new Date(startdate);
          const endDate = new Date(enddate);

          // console.log('startDate',startDate);
          // console.log('endDate',endDate);

          // Calculate the difference in days
          const timeDifference = endDate - startDate;
          const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24)); // Convert milliseconds to days
          // let monthsDifference = endDate.getMonth() - startDate.getMonth() + (12 * (endDate.getFullYear() - startDate.getFullYear()));
          let monthsDifference =
            (endDate.getFullYear() - startDate.getFullYear()) * 12 +
            (endDate.getMonth() - startDate.getMonth());

          // console.log('Initial monthsDifference:', monthsDifference);

          // console.log('endDate.getMonth()',endDate.getMonth());
          // console.log('startDate.getMonth()',startDate.getMonth());

          // Adjust months difference if the endDate day is earlier than startDate day in the end month
          if (endDate.getMonth() < startDate.getMonth()) {
            console.log("in the if");

            monthsDifference--;

            console.log(
              "Adjusted monthsDifference after day check:",
              monthsDifference
            );
          }
          monthsDifference++;
          // console.log('Final monthsDifference:', monthsDifference);

          // const weeksDifference = Math.floor(daysDifference / 7);
          const timeDiff = endDate - startDate;
          const weeksDifference = Math.ceil(timeDiff / (1000 * 3600 * 24 * 7));

          // console.log("Difference in days: ", daysDifference);

          // Initialize servicesToAdd array to hold all the service objects
          const servicesToAdd = [];

          existingServices.form1.services.forEach((service) => {
            // if (service?.servicechargetype !== "month") {
            if (billingschedule === "daily") {
              for (let i = 0; i <= daysDifference; i++) {
                const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                // console.log('userTimezone',userTimezone);
                
                // const serviceDate = new Date(startDate);
                // serviceDate.setDate(serviceDate.getDate() + i);
                const currentMoment = moment.tz(startDate, userTimezone).add(i, "days");
                // console.log('currentMoment',currentMoment);

                const formatted = currentMoment.format("YYYY-MM-DD");

                // console.log('formatted',formatted);
                

                servicesToAdd.push({
                  ...service,
                  patientId: existingServices.id,
                  serviceRate: 0,
                  totalCost: 0,
                  billingschedule: 'daily',
                  serviceDate: `${formatted} - ${formatted}`,
                   // serviceDate: new Date(serviceDate).toISOString().split("T")[0], // Use the incremented date
                //   serviceDate: new Date(
                //     serviceDate.setDate(serviceDate.getDate() + 1)
                //   )
                //     .toISOString()
                //     .split("T")[0],

                
                 });
              }
            }
          });

          existingServices.form1.services.forEach((service) => {
            // For monthly billing schedule
            if (billingschedule === "monthly") {
              console.log("in the month");

              const userTimezone =
                Intl.DateTimeFormat().resolvedOptions().timeZone;
              let current = moment.tz(startDate, userTimezone);

              for (let i = 0; i < monthsDifference; i++) {
                let monthStart;
                let monthEnd;

                if (i === 0) {
                  monthStart = moment
                    .tz(startDate, userTimezone)
                    .startOf("day");
                } else {
                  monthStart = moment(current).startOf("month");
                }

                monthEnd = moment(monthStart).endOf("month");

                if (i === monthsDifference - 1) {
                  monthEnd = moment.tz(endDate, userTimezone).endOf("day");
                }

                servicesToAdd.push({
                  ...service,
                  patientId: existingServices.id,
                  serviceRate: 0,
                  totalCost: 0,
                  serviceDate: `${monthStart.format(
                    "YYYY-MM-DD"
                  )} - ${monthEnd.format("YYYY-MM-DD")}`,
                  billingschedule: "monthly",
                });

                // Move to next month
                current.add(1, "month");
              }
            }

            // For weekly billing schedule
            if (billingschedule === "weekly") {
              // let current = new Date(startDate);  // Start from the selected start date
              const userTimezone =
                Intl.DateTimeFormat().resolvedOptions().timeZone;

              let current = moment.tz(startDate, userTimezone).startOf("day");
              const finalDate = moment.tz(endDate, userTimezone).endOf("day");
              let isFirstWeek = true;

              while (current.isSameOrBefore(finalDate, "day")) {
                let weekStart = moment(current);
                let weekEnd;

                if (isFirstWeek) {
                  // First week ends on the upcoming Saturday
                  const dayOfWeek = weekStart.day(); // 0 = Sunday, 6 = Saturday
                  const daysUntilSaturday = 6 - dayOfWeek;
                  weekEnd = moment(weekStart).add(daysUntilSaturday, "days");
                  isFirstWeek = false;
                } else {
                  weekStart = moment(current).startOf("week"); // Sunday
                  weekEnd = moment(current).endOf("week"); // Saturday
                }

                if (weekEnd.isAfter(finalDate)) {
                  weekEnd = moment(finalDate);
                }

                servicesToAdd.push({
                  ...service,
                  patientId: existingServices.id,
                  serviceRate: 0,
                  totalCost: 0,
                  serviceDate: `${weekStart.format(
                    "YYYY-MM-DD"
                  )} - ${weekEnd.format("YYYY-MM-DD")}`,
                  billingschedule: "weekly",
                });

                // Move to the next week: Sunday after current weekEnd
                current = moment(weekEnd).add(1, "day").startOf("day");
              }
            }
            // For exact date billing schedule

            if(billingschedule === "exactdate"){


              console.log("in exactdate");
              const userTimezone =
              Intl.DateTimeFormat().resolvedOptions().timeZone;

              const oneTimeStart = moment.tz(startDate, userTimezone).startOf("day");
              const oneTimeEnd = moment.tz(endDate, userTimezone).endOf("day");
            
              servicesToAdd.push({
                ...service,
                patientId: existingServices.id,
                serviceRate: 0,
                totalCost: 0,
                serviceDate: `${oneTimeStart.format("YYYY-MM-DD")} - ${oneTimeEnd.format("YYYY-MM-DD")}`,
                billingschedule: "exactdate",
              });
            }



          });

          // existingServices.form1.services.forEach((service) => {
          //    if (service?.servicechargetype === "month") {
          //   //  if (billingschedule === "monthly") {
          //     servicesToAdd.push({
          //       ...service,
          //       patientId: existingServices.id,
          //       serviceRate: 0,
          //       totalCost: 0,
          //       serviceDate: "",
          //     });
          //   }
          // });

          initializedServices = [...initializedServices, ...servicesToAdd];
        }
      }

      setProviderServices(initializedServices);
    }
  }, [existingServices]);

  const handleServiceRateChange = (index, value) => {
    const updatedServices = [...providerServices];
    const serviceRate = parseFloat(value) || 0;

    updatedServices[index].serviceRate = serviceRate;
    updatedServices[index].totalCost =
      // serviceRate * updatedServices[index].servicechargeAmount;
      serviceRate * updatedServices[index].servicechargeNumber;
      
    // updatedServices[index].totalCost = (
    //   (serviceRate /
    //     (isNaN(Number(updatedServices[index].servicechargetype))
    //       ? 1
    //       : Number(updatedServices[index].servicechargetype))) *
    //   updatedServices[index].servicechargeAmount
    // ).toFixed(2);

    setProviderServices(updatedServices);
  };

  const handleServiceDateChange = (index, value, type) => {
    const updatedServices = [...providerServices];
    const currentDateRange = updatedServices[index].serviceDate || "";
    console.log('currentDateRange',currentDateRange);
    
    const [start = "", end = ""] = currentDateRange.split(" - ");

    const newStart =
      type === "start" ? moment(value).format("YYYY-MM-DD") : start;
    const newEnd = type === "end" ? moment(value).format("YYYY-MM-DD") : end;

    updatedServices[index].serviceDate = `${newStart} - ${newEnd}`;
    setProviderServices(updatedServices);
  };



  const handleSubmit = async () => {
    const checkingServices = [...providerServices];

    // console.log('checkingServices here', checkingServices);
    // console.log('finalServices', finalservices);

    // const invalidService = checkingServices.find(service => {
    //   // const totalCost = service.serviceRate * service.servicechargeAmount;
    //   const totalCost=parseFloat((
    //     (service.serviceRate /
    //     (isNaN(Number(service?.servicechargetype)) ? 1 : Number(service?.servicechargetype))
    //     ) * (isNaN(Number(service?.servicechargeAmount)) ? 0 : Number(service?.servicechargeAmount))
    //   ).toFixed(2))
    //   return totalCost === 0;
    // });

    // if (invalidService) {
    //   await swal({
    //     title: "Invalid Service Cost",
    //     text: "'Service cost cannot be zero!",
    //     icon: "warning",
    //     dangerMode: true,
    //   });
    //   return;
    // }

    const updatedServices = finalservices.map((existingService) => {
      const matchingService = checkingServices.find(
        (service) =>
          service.patientId === existingService.patientId &&
          service.servicetitle === existingService.servicetitle &&
          service.servicenumber === existingService.servicenumber
      );

      if (matchingService) {
        return {
          ...existingService,
          serviceRate: matchingService.serviceRate,
          totalCost:
           // matchingService.serviceRate * matchingService.servicechargeAmount,
            matchingService.serviceRate * matchingService.servicechargeNumber,
            

          //   totalCost:
          //     (matchingService.serviceRate /
          //       (isNaN(Number(matchingService?.servicechargetype))
          //         ? 1
          //         : Number(matchingService?.servicechargetype))) *
          //     Number(matchingService?.servicechargeAmount).toFixed(2),
        };
      }

      return existingService;
    });

    const newServices = checkingServices
      .filter(
        (service) =>
          !finalservices.some(
            (existingService) =>
              existingService.patientId === service.patientId &&
              existingService.servicetitle === service.servicetitle &&
              existingService.servicenumber === service.servicenumber
          )
      )
      .map((service) => {
        return {
          ...service,
          serviceRate: service.serviceRate,
          // totalCost: service.serviceRate * service.servicechargeAmount,
          totalCost: service.serviceRate * service.servicechargeNumber,
          
          // totalCost:
          //   (service.serviceRate /
          //     (isNaN(Number(service?.servicechargetype))
          //       ? 1
          //       : Number(service?.servicechargetype))) *
          //   Number(service?.servicechargeAmount).toFixed(2),
        };
      });

    console.log("updatedServices", updatedServices);
    console.log("newServices", newServices);

    const finalUpdatedServices = [...updatedServices, ...newServices];

    // console.log('finalUpdatedServices', finalUpdatedServices);

    SetFinalServcices(finalUpdatedServices);



    // localStorage.setItem("finalservices", JSON.stringify(finalUpdatedServices));

    handleClose();
  };

  const handleClose = () => {
    setShowservices(false);
    setEdit(false);
  };

  return (
    <Modal
      opened={showservice}
      size={1000}
      title={existingServices?.form1?.name || ""}
      shadow="md"
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      radius={"lg"}
      zIndex={1000}
      centered
      styles={{
        title: {
          color: "var(--app-text)",
          fontWeight: "bold",
          fontSize: "24px",
        },
      }}
    >
      <Box className={classes.container}>
        <Box className={classes.addbox}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Text ff={"inter"} fs={14} fw={500} color="var(--app-text)">
              Client Service Details
            </Text>

            {billingdate?.billingdata === "billingprogressnote" ? (
              <>
                <Box
                  onClick={() => {
                    setEdit(true);
                  }}
                  style={{
                    display: "flex",
                    gap: "4px",
                    // justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <img
                    // className="img"
                    width={20}
                    height={20}
                    src="/assets/images/serviceedit.png"
                    alt="home"
                  />
                  <Text ff="Inter" fz={15} fw={600} color="#DC6803">
                    Edit
                  </Text>
                </Box>
              </>
            ) : null}
          </Box>

          <div className={classes.searchResultListWrapper}>
            <ScrollArea
              onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
              sx={{ minHeight: "300px" }}
            >
              <Table
                highlightOnHover={true}
                enableStickyHeader={true}
                sx={{
                  fontFamily: "Inter",
                  // borderRadius: "5px",
                  // border: "1px solid var(--app-border)",
                }}
                className={classes.searchResultList}
                striped
                bordered
              >
                <thead className={classes.tableHead}>
                  <tr>
                    {/* <th className={classes.header}>Service Name</th>
          <th className={classes.header}>Code</th>
          <th className={classes.header}>Value Type</th>
          <th className={classes.header}>Approved Unit</th>
          <th className={classes.header}>Unit Charge</th>
          <th className={classes.header}>Service Unit</th>
          <th className={classes.header}>Service Charge</th> */}
                    <th className={classes.header}>Start Date</th>
                    <th className={classes.header}>End Date</th>
                    <th className={classes.header}>Service Name</th>
                    <th className={classes.header}>Code</th>
                    <th className={classes.header}>Value Type</th>
                    <th className={classes.header}>Approved Unit</th>
                    <th className={classes.header}>Unit Charge</th>
                    <th className={classes.header}>Service Unit</th>
                    <th className={classes.header}>Service Charge</th>
                  </tr>
                </thead>
                <tbody>
                  {providerServices?.length > 0 ? (
                    providerServices.map((existingService, index) => (
               

                      <tr key={index}>
                      
                 

                        <td>
                          <DatePickerInput
                            maxDate={today}
                            position="bottom"
                            disabled={!existingService.billingschedule}
                            // value={
                            //   existingService?.serviceDate && (existingService.billingschedule === 'monthly' || existingService.billingschedule === 'weekly')
                            //     ? new Date(existingService?.serviceDate.split(' - ')[0])
                            //     : existingService?.serviceDate
                            //     ? new Date(existingService?.serviceDate)
                            //     : billingdate?.startdate
                            //     ? new Date(billingdate?.startdate)
                            //     : null
                            // }
                            value={
                              existingService?.serviceDate && 
                              (existingService.billingschedule === "monthly" ||
                                existingService.billingschedule === "weekly" || existingService.billingschedule === "daily" || existingService.billingschedule === "exactdate" )
                                ? (() => {
                                    const raw =
                                      existingService?.serviceDate.split(
                                        " - "
                                      )[0];
                                    const [year, month, day] = raw
                                      .split("-")
                                      .map(Number);
                                    return new Date(year, month - 1, day); // safe way
                                  })()
                                : 
                                
                                existingService?.serviceDate &&  existingService?.serviceDate !==""
                                ? 
                                
                                (() => {
                                  const raw =
                                    existingService?.serviceDate?.split(
                                      " - "
                                    )[0];
                                  const [year, month, day] = raw
                                    .split("-")
                                    .map(Number);
                                  return new Date(year, month - 1, day); 
                                })()
                                // new Date(existingService?.serviceDate)
                                : billingdate?.startdate
                                ? 
                                new Date(billingdate?.startdate)
                                // (() => {
                                //     const [year, month, day] =
                                //       billingdate.startdate
                                //         .split("-")
                                //         .map(Number);
                                //     return new Date(year, month - 1, day);
                                //   })()
                                : null
                            }
                            onChange={(e) =>
                              handleServiceDateChange(index, e, "start")
                            }
                            variant="unstyled"
                            size="xs"
                            valueFormat="MM/DD/YYYY"
                            style={{
                              fontSize: 14,
                              fontWeight: 400,
                              color: "var(--app-text)",
                              width: "100%",
                            }}
                            placeholder="Start Date"
                          />
                        </td>

                        <td>
                          <DatePickerInput
                            maxDate={today}
                            dropdownType="popover"
                            position="top"
                            disabled={!existingService.billingschedule}
                            
                            // value={
                            //   existingService?.serviceDate && (existingService.billingschedule === 'monthly' || existingService.billingschedule === 'weekly')
                            //     ? new Date(existingService?.serviceDate.split(' - ')[1])
                            //     : billingdate?.enddate
                            //     ? new Date(billingdate?.enddate)
                            //     : null
                            // }
                            value={
                              existingService?.serviceDate &&
                              (existingService.billingschedule === "monthly" ||
                                existingService.billingschedule === "weekly" ||   existingService.billingschedule === "daily")
                                ? (() => {
                                    const raw =
                                      existingService?.serviceDate.split(
                                        " - "
                                      )[1];
                                    if (!raw) return null;
                                    const [year, month, day] = raw
                                      .split("-")
                                      .map(Number);
                                    return new Date(year, month - 1, day); // ✅ safe, avoids UTC shift
                                  })()
                             
                                
                               : existingService?.serviceDate &&  existingService?.serviceDate!==""
                                ? 
                                
                                (() => {
                                  const raw =
                                    existingService?.serviceDate.split(
                                      " - "
                                    )[1];
                                  if (!raw) return null;
                                  const [year, month, day] = raw
                                    .split("-")
                                    .map(Number);
                                  return new Date(year, month - 1, day); // ✅ safe, avoids UTC shift
                                })()
                           
                                
                               // new Date(existingService?.serviceDate)
                                : billingdate?.enddate
                                ? 
                                new Date(billingdate?.enddate)
                               :null
                            }
                            onChange={(e) =>
                              handleServiceDateChange(index, e, "end")
                            }
                            variant="unstyled"
                            size="xs"
                            valueFormat="MM/DD/YYYY"
                            style={{
                              fontSize: 14,
                              fontWeight: 400,
                              color: "var(--app-text)",
                              width: "100%",
                            }}
                            placeholder="End Date"
                          />
                        </td>

                        <td>
                          <Text fz={14} fw={400} color="var(--app-text)">
                            {existingService?.servicetitle}
                          </Text>
                        </td>
                        <td>{existingService?.servicenumber}</td>

                        <td>
                          <Input
                            className={classes.input}
                            type="text"
                            value={
                              existingService?.servicechargetype === "15" ||
                              existingService?.servicechargetype === "45" ||
                              existingService?.servicechargetype === "30"
                                ? `${existingService?.servicechargetype} Min`
                                : existingService?.servicechargetype || "N/A"
                            }
                            readOnly
                          />
                        </td>

                        <td>
                          <Input
                            className={classes.input}
                            type="text"
                            value={
                              existingService?.servicechargeAmount || "N/A"
                            }
                            readOnly
                          />
                        </td>

                        <td>
                          <Input
                            className={classes.input}
                            type="text"
                            value={`$${
                              existingService?.servicechargeNumber || "N/A"
                            }`}
                            readOnly
                          />
                        </td>

                        <td>
                          <Input
                            type="number"
                            value={existingService?.serviceRate || ""}
                            disabled={
                              billingdate?.billingdata ===
                                "billingprogressnote" && !edit
                            }
                            onChange={(e) =>
                              handleServiceRateChange(index, e.target.value)
                            }
                          />
                        </td>

                        <td>
                          <Input
                            className={classes.input}
                            type="text"
                            value={`$${existingService?.totalCost || " - "}`}
                            readOnly
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={8}
                        style={{ textAlign: "center", color: "gray" }}
                      >
                        No billing notes for that service
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </ScrollArea>
          </div>
        </Box>

        <Box
          style={{ gap: "20px", marginTop: "32px" }}
          className={classes.flexend}
        >
          <Button
            onClick={handleClose}
            variant="default"
            c="var(--app-text)"
            radius="md"
            size="md"
            bg="var(--app-surface-2)"
          >
            Back
          </Button>

          <Button
            onClick={handleSubmit}
            variant="filled"
            c="var(--app-on-primary)"
            radius="md"
            size="md"
            sx={{ backgroundColor: "var(--app-primary)", color: "var(--app-on-primary)", "&:hover": { backgroundColor: "var(--app-primary)", filter: "brightness(0.95)" } }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default ViewClientClaimServices;
